/**
 * Created by WorkAxis www.workaxis.in
 * Developer: Padma Dev.E
 * Developer Contact: padmadev.e@workaxis.in
 * Admin: shyam@workaxis.in
 * Date: 3/23/2022
 * Time: 5:27 PM
 * Project: w_crm
 */
import React from "react";
import { toast } from "react-toastify";

export function Toast(title, type = "success") {
  let auto = 1000;
  let progress = false;
  let position = "top-center";

  if (type === "error") {
    auto = 3000;
  } else if (type === "disappear-error") {
    auto = 3000;
    type = "error";
  }

  toast(title, {
    position: position,
    type: type,
    autoClose: auto,
    hideProgressBar: progress,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
}
